// LoadingPlugin.js
import Loading from '@/components/Loading.vue'

const LoadingPlugin = {
  install(Vue) {
    Vue.component('Loading', Loading)

    const LoadingConstructor = Vue.extend(Loading)
    let loadingInstance = null

    Vue.prototype.$loading = {
      show(options = {}) {
        if (!loadingInstance) {
          loadingInstance = new LoadingConstructor({
            propsData: options,
            el: document.createElement('div')
          })

   
          let container = document.body
          if (options.maskFullscreen === false && options.container) {
            container = typeof options.container === 'string' 
              ? document.querySelector(options.container) 
              : options.container
            
           
            if (window.getComputedStyle(container).position === 'static') {
              container.style.position = 'relative'
            }
          }

          container.appendChild(loadingInstance.$el)
        }
        return loadingInstance
      },
      hide() {
        if (loadingInstance) {
          loadingInstance.$el.parentNode.removeChild(loadingInstance.$el)
          loadingInstance.$destroy()
          loadingInstance = null
        }
      }
    }
  }
}

export default LoadingPlugin